var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCardIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 .5h24A3.5 3.5 0 0 1 31.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20V4l.005-.18A3.5 3.5 0 0 1 4 .5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D9D9D9",
  d: "M4 .5h24A3.5 3.5 0 0 1 31.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20V4l.005-.18A3.5 3.5 0 0 1 4 .5Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#creditCardIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M7.797 10.633v5.742a1.64 1.64 0 0 0 1.64 1.64h13.126a1.64 1.64 0 0 0 1.64-1.64v-5.742zm6.016 4.101H10.53v-1.093h3.281zm6.72.389a.93.93 0 0 1-.705-.323.934.934 0 1 1 0-1.225.935.935 0 1 1 .706 1.548M7.798 8.993V7.624a1.64 1.64 0 0 1 1.64-1.64h13.126a1.64 1.64 0 0 1 1.64 1.64v1.367z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "creditCardIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.25 3.25h17.5v17.5H7.25z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardIcon);
export default ForwardRef;